import { useEffect, useRef } from "react";
import { useLocation } from "react-router";
import { buildHit, sendHit } from "./hit";

export function RouteHit() {
  const location = useLocation();
  const lastKey = useRef<string | null>(null);

  useEffect(() => {
    const key = `${location.pathname}${location.search}`;
    if (lastKey.current === key) return;
    lastKey.current = key;
    sendHit(buildHit(location.pathname, location.search));
  }, [location.pathname, location.search]);

  return null;
}
